import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, className, children }) => {
  if (!isOpen) return null;

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center`}
      style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={onClose}
    >
      <div
        className={`bg-gray-800 rounded-lg p-6 mx-4 relative default-modal ${className}`}
        style={{ maxHeight: '100dvh', overflowY: 'auto', boxSizing: 'border-box', maxWidth: 'calc(100vw - 32px)' }}
        onClick={(e) => e.stopPropagation()}
      >
        {onClose &&
          <button
            onClick={onClose}
            className="modal-close"
            aria-label="Close modal"
          >
            ×
          </button>
        }

        {children}
      </div>
    </div>
  );
};

export default Modal;
